import { history } from '../helpers';
import { studentConstants } from '../constants';
import { studentService } from '../services';
import { showToast } from '../services/toast';

export const studentActions = {
  fetchStudents,
  createStudents,
  updateStudents,
  deleteStudent,
  regenerateAccesscode,
};


function fetchStudents(classid) {

  return dispatch => {
    dispatch(request());

    studentService.getStudentList(classid)
      .then(
        response => {
          dispatch(success(response.data));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: studentConstants.FETCH_STUDENTS_REQUEST } }
  function success(students) { return { type: studentConstants.FETCH_STUDENTS_SUCCESS, students } }
  function failure(error) { return { type: studentConstants.FETCH_STUDENTS_FAILURE, error } }
}


function createStudents(students) {
  return dispatch => {
    dispatch(request());

    return studentService.createStudents(students)
      .then(
        response => {
          showToast(response.responseMessage, 'success');
          dispatch(success(response.data));
          // history.push({ pathname: "/classsetup" })
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: studentConstants.CREATE_STUDENTS_REQUEST } }
  function success(students) { return { type: studentConstants.CREATE_STUDENTS_SUCCESS, students } }
  function failure(error) { return { type: studentConstants.CREATE_STUDENTS_FAILURE, error } }
}

function updateStudents(students) {

  return dispatch => {
    dispatch(request());

    studentService.updateStudents(students)
      .then(
        students => {
          dispatch(success(students.data));
          showToast(students.responseMessage, 'success');
          // history.push({ pathname: "/classsetup" })
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: studentConstants.UPDATE_STUDENTS_REQUEST } }
  function success(students) { return { type: studentConstants.UPDATE_STUDENTS_SUCCESS, students } }
  function failure(error) { return { type: studentConstants.UPDATE_STUDENTS_FAILURE, error } }
}


function deleteStudent(classID, studentProfileID) {
  return dispatch => {
    dispatch(request());

    studentService.deleteStudent(classID, studentProfileID)
      .then(
        (response) => {

          if (response.responseMessage === "Active student cant be deleted") {
            dispatch(failure(response.responseMessage));
            showToast(response.responseMessage, 'warn');
            return;
          }

          dispatch(success(studentProfileID));
          showToast(response.responseMessage, 'success');
        },
        error => {
          dispatch(failure(studentProfileID, error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: studentConstants.DELETE_STUDENT_REQUEST } }
  function success(id) { return { type: studentConstants.DELETE_STUDENT_SUCCESS, payload: id } }
  function failure(error) { return { type: studentConstants.DELETE_STUDENT_FAILURE, error } }
}


function regenerateAccesscode(studentid) {
  return dispatch => {
    dispatch(request());

    studentService.regenerateAccesscode(studentid)
      .then(
        response => {
          if (response.data && response.data.length > 0) {
            dispatch(success(response.data[0]));
          }
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: studentConstants.UPDATE_ACCESSCODE_REQUEST }; }
  function success(accesscode) { return { type: studentConstants.UPDATE_ACCESSCODE_SUCCESS, accesscode }; }
  function failure(error) { return { type: studentConstants.UPDATE_ACCESSCODE_FAILURE, error }; }
}
